import React from 'react';
import Column from 'canvas-core-react/lib/Column';
// import Margin from 'canvas-core-react/lib/Margin';
import TextHeadline from 'canvas-core-react/lib/TextHeadline';
import TextCaption from 'canvas-core-react/lib/TextCaption';
import TextLegal from 'canvas-core-react/lib/TextLegal';
import Row from 'canvas-core-react/lib/Row';
import Margin from 'canvas-core-react/lib/Margin';
import IconInformationIllustrativeOutline from 'canvas-core-react/lib/IconInformationIllustrativeOutline';

// ICONS
import { ReactComponent as Icon } from '../icons/icon_infobanner.svg';

import TextAlign from '../../utils/TextAlign';
// STYLES
import './infoBanner.scss';

const InfoBanner = () => {

    return (
        <>
            <Margin side='top' lg={36}>
                <Column lgOffset={1.75} lg={8.5} style={{ paddingLeft: '0' }}>
                    <Row>
                        <Column xs={4} sm={4} md={6} lg={6} style={{ paddingLeft: '12rem', paddingRight: '2rem' }} className='infobanner_1'>
                            <TextHeadline size='extraSmall' component="h1" className='infobanner infobanner_title'>Información a considerar</TextHeadline>
                            <Margin side="top" xs={18} sm={18} md={18}>
                                <div style={{ display: 'flex', alignItems: 'start' }}>
                                    <TextAlign>
                                        <IconInformationIllustrativeOutline style={{ width: '18px', marginTop: '-2px' }} />
                                    </TextAlign>
                                    <TextCaption component="p" style={{ textAlign: 'start', marginLeft: '0.8rem' }} className='infobanner_t'>
                                        Los requisitos necesarios para contratar son: ser mayor de 18 años, cédula de identidad vigente, ser persona natural,
                                        con residencia definitiva y tener una cuenta bancaria activa.
                                    </TextCaption>
                                </div>
                            </Margin>

                            <Margin side="top" xs={18} sm={18} md={18} lg={18}>
                                <div style={{ display: 'flex', alignItems: 'start' }}>
                                    <TextAlign>
                                        <IconInformationIllustrativeOutline style={{ width: '18px', marginTop: '-2px' }} />
                                    </TextAlign>
                                    <TextCaption component="p" style={{ textAlign: 'start', marginLeft: '0.8rem' }} className='infobanner_t'>
                                        Los bancos habilitados para pagar el monto inicial de tu Depósito a Plazo son: Banco BCI.
                                    </TextCaption>
                                </div>
                            </Margin>

                            <Margin side="top" xs={18} sm={18} md={18} lg={18}>
                                <div style={{ display: 'flex', alignItems: 'start' }}>
                                    <TextAlign>
                                        <IconInformationIllustrativeOutline style={{ width: '18px', marginTop: '-2px' }} />
                                    </TextAlign>
                                    <TextCaption component="p" style={{ textAlign: 'start', marginLeft: '0.8rem' }} className='infobanner_t'>
                                        Los Depósitos a Plazo se efectúan en pesos (CLP).
                                    </TextCaption>
                                </div>
                            </Margin>

                            <Margin side="top" xs={18} sm={18} md={18} lg={18}>
                                <div style={{ display: 'flex', alignItems: 'start' }}>
                                    <TextAlign>
                                        <IconInformationIllustrativeOutline style={{ width: '18px', marginTop: '-2px' }} />
                                    </TextAlign>
                                    <TextCaption component="p" style={{ textAlign: 'start', marginLeft: '0.8rem' }} className='infobanner_t'>
                                        Las tasas entregadas por la simulación en www.scotia.cl serán válidas únicamente para dicho canal, para el plazo y
                                        la fecha en que se  realiza la consulta.
                                    </TextCaption>
                                </div>
                            </Margin>
                        </Column>
                        <Column xs={2} sm={4} md={6} lg={6} xsHide smHide className='benefitsbanner-icon'>
                            <Icon />
                        </Column>
                    </Row>
                    <Margin side='top' lg={24} className='infobanner_hidden'>
                        <div style={{ borderTop: '1px solid #E2E8EE' }} />
                    </Margin>
                    <Margin lg={[72, 0, 48, 0]}>
                        <Column style={{ padding: '0' }} className='infobanner_legal'>
                            <TextLegal component="p">
                                · Monto mínimo de inversión: $50.000, en plazo entre 7 y 365 días.<br />
                                · Los depósitos se emiten en modalidad nominativo, con custodia electrónica.<br />
                                · Scotia no acepta solicitudes de pago anticipado de Depósitos a Plazo.<br />
                                · Los Depósitos a Plazo Renovables se renuevan automáticamente al tercer día hábil bancario siguiente
                                del vencimiento, por el mismo plazo inicial y a la tasa vigente del día de vencimiento.<br />
                                · El pago de Depósitos a Plazo se efectuará con abono a tu Cuenta Corriente en pesos de Scotia.<br />
                                · Infórmese sobre la garantía estatal de los depósitos en su banco o en www.cmfchile.cl<br />
                            </TextLegal>
                        </Column>
                    </Margin>
                </Column>
            </Margin>
        </>

    )
}

export default InfoBanner;